<template>
  <div class="wrap" :class="{ newWrap: canCancelSubscription }">
    <div class="tab">
      <div
        class="title"
        :class="{ active: activeTab === 'rule' }"
        @click="activeTab = 'rule'"
      >
        使用规则
      </div>
      <div
        v-if="canCancelSubscription"
        class="title"
        :class="{ active: activeTab === 'renewal' }"
        @click="activeTab = 'renewal'"
      >
        续费管理
      </div>
    </div>
    <RuleComponent
      v-if="activeTab === 'rule'"
      :canCancelSubscription="canCancelSubscription"
    />
    <RenewalComponent v-if="activeTab === 'renewal'" :jyCardInfo="jyCardInfo" />
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
} from "@vue/composition-api";
import Vue from "vue";

import { useStore, useRoute } from "@/components/use/base";

import RuleComponent from "./component/RuleComponent.vue";
import RenewalComponent from "./component/RenewalComponent.vue";

import { getJiayinDetail, jiayinQueryMonthlySubscription } from "@/apis/jiayin";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    RuleComponent,
    RenewalComponent,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const { info } = route.query;

    const activeTab = ref("rule");
    const jyCardInfo = ref({});
    const canCancelSubscription = ref(false);

    const namespace = computed(() => store.state.namespace);
    const packageName = computed(
      () => store.state.userInfo.card_type || store.state.namespaceInfo.package
    );
    const showCancelRenewalModal = computed(
      () => store.state.JiaYin.showCancelRenewalModal
    );

    watch(
      showCancelRenewalModal,
      (newVal) => {
        if (newVal) {
          activeTab.value = "renewal";
        }
      },
      { immediate: true, deep: true }
    );

    const initJyData = async () => {
      const fetching = vm.$loading();
      try {
        const { data } = await getJiayinDetail({
          orderId: store.state.orderId,
          packageCode: packageName.value || namespace.value.toUpperCase(),
          info: info || sessionStorage.getItem("JY_INFO"),
        });
        const { data: monthlyData } = await jiayinQueryMonthlySubscription({
          orderId: store.state.orderId,
        });
        canCancelSubscription.value =
          monthlyData?.continuousMonthlyStatus === "ACTIVE" || false;
        jyCardInfo.value = data || {};
      } finally {
        fetching.clear();
      }
    };

    onMounted(() => {
      initJyData();
    });

    return {
      activeTab,
      jyCardInfo,
      canCancelSubscription,
    };
  },
});
</script>

<style scoped lang="less">
.wrap {
  width: 100%;
  padding: 0 12px;
  min-height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  background: rgb(250, 243, 234);

  &.newWrap {
    background: #fff;
  }
}

.tab {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 24px;

  .title {
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    line-height: 16px;
    padding-bottom: -3px;
    font-size: 18px;
    color: #666666;
    font-weight: 400;

    &.active {
      font-weight: 600;
      color: #333333;
      border-bottom: 2px solid #e4d1b4;
    }
  }
}
</style>
